export default __webpack_public_path__ + "4ee10f744bdb8c3f77ae88c5b569e6f1.png";